import NotePreview from './NotePreview';

export default NotePreview;